import { Divider } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import SelectedEmailCategoryAction from "components/Shared/SelectedEmail/Actions/Category";
import SelectedEmailDefaultActions from "components/Shared/SelectedEmail/Actions/DefaultActions";

const fragment = gql(/* GraphQL */ `
  fragment BrandSelectedEmailActions on ReceivedEmailMessage {
    ...SelectedEmailCategoryAction
    ...SelectedEmailDefaultActions
  }
`);

type Props = {
  data: FragmentType<typeof fragment> | null | undefined;
};

export default function SelectedEmailActions({ data }: Props) {
  const rem = getFragmentData(fragment, data);

  return (
    <>
      <SelectedEmailCategoryAction data={rem} />
      <Divider my={4} />
      <SelectedEmailDefaultActions data={rem} />
    </>
  );
}
